<mat-dialog-content>
  <div class="header-section mat-header-row">
    <h1 [ngClass]="{ rtl: rightToLeftSite }">{{ (customVariables$ | async)[data.title] }}</h1>
    <mat-icon
      class="close-cross"
      tabindex="0"
      role="button"
      aria-label="close"
      aria-hidden="false"
      (click)="onCrossClick()"
      (keyup.enter)="onCrossClick()"
      (keyup.space)="onCrossClick()"
      >close</mat-icon
    >
  </div>
  <div class="modal-body" [ngClass]="{ rtl: rightToLeftSite }">
    <p *ngFor="let translation of data?.translations" class="mat-body" [innerHTML]="translation | translate"></p>
  </div>
  <div class="bottom-container">
    <form [formGroup]="form">
      <mat-form-field class="example-full-width">
        <input
          matInput
          id="card-num-field"
          formControlName="cardNumber"
          aria-describedby="invalid-error"
          [placeholder]="
            (customVariables$ | async)?.mtls_producteligibility_cardnumber ||
            ('CheckEligibilityMastercard:CardNumber' | translate)
          "
        />
        <mat-error
          id="invalid-error"
          role="alert"
          when="touched"
          ngxErrors="cardNumber"
          ngxError="invalidCardNumber"
          [translate]="'CheckEligibilityMastercard:InvalidCardNumber'"
        >
        </mat-error>
      </mat-form-field>
    </form>
    <button
      mat-raised-button
      color="primary"
      id="check-eligibility-button"
      class="submit-button"
      (click)="enableRecaptcha ? onSubmit() : onEligibilityDetailsSubmitted('')"
      (keyup.enter)="enableRecaptcha ? onSubmit() : onEligibilityDetailsSubmitted('')"
      (keyup.space)="enableRecaptcha ? onSubmit() : onEligibilityDetailsSubmitted('')"
      [disabled]="!form.valid || productHomepageService.eligibilityCheckLoading"
    >
      <span [translate]="'Button:CheckEligibility'" *ngIf="!productHomepageService.eligibilityCheckLoading">
        Check Eligibility
      </span>
      <mat-spinner *ngIf="productHomepageService.eligibilityCheckLoading" diameter="30"></mat-spinner>
    </button>
  </div>
</mat-dialog-content>

<re-captcha
  *ngIf="captchaLanguage && enableRecaptcha"
  site_key="6LeS4KsUAAAAAH5apd5lwvbc8WLWNgi16d2CprVP"
  size="invisible"
  language="{{ captchaLanguage }}"
  [tabindex]="-1"
  [global]="true"
  (captchaResponse)="onEligibilityDetailsSubmitted($event)"
>
</re-captcha>
